import { patch } from '..';
import routes from './routes';

const ProfileServices = {
  updateProfile: async (obj) => {
    const data = await patch(routes.updateProfile, obj);
    return data;
  },
}

export default ProfileServices